/**
 * Model responsible for handling an accounting document state.
 * It fetches the data, stores them and manipulates them at the will of the controller.
 * The fetching/updating is done through a dedicated service.
 *
 * @abstract
 * @param {AccountingDocumentService} service - Service responsible for fetching/updating the data asynchronously
 */
export default class AccountingDocumentState {
	constructor({ service } = {}) {
		this._service = service;
	}

	async setup(...rest) {
		const initialData = await this._service.fetchInitialData(...rest);

		await this._setupInitialData({
			...rest[0],
			...initialData,
		});
	}

	_setupInitialData(_) {
		return Promise.resolve();
	}
}
